'use client';

import classNames from 'classnames';
import { FunctionComponent, useEffect, useState } from 'react';

import { PropsWithClassname } from '@/app/types';
import { User } from '@/app/api';

import ProfileNavigation from '@/app/components/ProfileNavigation/ProfileNavigation';
import CrossIcon from '@/app/components/CrossIcon/CrossIcon';

interface DrawerProfileNavigationProps extends PropsWithClassname {
  isOpen: boolean;
  onClose: () => void;
  currentUser: User;
}

const DrawerProfileNavigation: FunctionComponent<DrawerProfileNavigationProps> = ({
  isOpen,
  currentUser,
  onClose,
  className,
}) => {
  const [isOverflowContainerVisible, setIsOverflowContainerVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setIsOverflowContainerVisible(true);
    } else {
      document.body.style.overflow = 'auto';
      setTimeout(() => {
        setIsOverflowContainerVisible(false);
      }, 200);
    }
  }, [isOpen]);

  return (
    <div
      id="drawer-profile-navigation"
      className={classNames('xl:hidden overflow-hidden absolute top-0 bottom-0 h-[100vh] z-30', {
        'w-full left-0 right-0': isOpen || isOverflowContainerVisible,
      })}
    >
      <div
        className={classNames(className, 'absolute lg:hidden w-full h-full transition-all bg-white px-[24px]', {
          'right-[-100%]': !isOpen,
          'right-0': isOpen,
        })}
      >
        <button onClick={onClose} className="absolute top-[26px] right-[28px]">
          <CrossIcon />
        </button>
        <ProfileNavigation currentUser={currentUser} className="pt-[80px]" />
      </div>
    </div>
  );
};

export default DrawerProfileNavigation;
